const STORAGE_KEY = "swivu.promote.resume.v2";

/** fileId → wizard step index */
type PromoteResumeStore = Record<string, number>;

function readStore(): PromoteResumeStore {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as PromoteResumeStore;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeStore(store: PromoteResumeStore) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // Quota / private mode — ignore
  }
}

export function getPromoteResumeStep(fileId: string | number): number | null {
  const step = readStore()[String(fileId)];
  return typeof step === "number" && Number.isFinite(step) ? step : null;
}

export function setPromoteResumeStep(fileId: string | number, stepIndex: number) {
  const fileKey = String(fileId);
  const store = readStore();
  if (store[fileKey] === stepIndex) return;
  store[fileKey] = stepIndex;
  writeStore(store);
}

export function clearPromoteResumeStep(fileId: string | number) {
  const fileKey = String(fileId);
  const store = readStore();
  if (!(fileKey in store)) return;
  delete store[fileKey];
  writeStore(store);
}
